<template>
    <div v-for="r of newReserves">
        <div class="flex flex-row gap-2">
            <span v-if="r.amount && r.currency_code" class="flex text-700 mb-2 text-sm">
                {{ get_format_amount(r.amount, r.currency_code) }}
            </span>
        </div>
    </div> 
    <div class="w-full">
        <Button label="Изменить" @click="displayPopup=true" class="mt-2" size="small" icon="pi pi-pencil" iconPos="right"/>
    </div>

    <Dialog header="Изменить резервы" class="xl:mx-2" modal
        v-model:visible="displayPopup" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '400px'}" >

        <div class="w-full flex flex-column gap-2 mb-3">
            <div v-for="r of newReserves" class="flex flex-row gap-2 w-full">
                <div class="flex flex-1 w-full">
                    <InputNumber placeholder="Резерв" v-model="r.amount" inputId="locale-us"
                        class="flex w-full border-2 border-round-lg surface-border"
                        :min-fraction-digits="0" :max-fraction-digits="0" :min="0" :max="99999999999" />
                    </div>
                <div class="flex justify-content-center align-items-center">
                    <span class="uppercase">{{ r.currency_code }}</span>
                </div>
                <div class="flex">
                    <Button @click='removeCurrency(r.currency_code)' :loading="loading" icon="pi pi-times" severity="secondary" outlined rounded />
                </div>
                
            </div>
        </div>
        <div class="flex flex-row gap-2">
            <Dropdown v-model="currency" :options="currencies" optionLabel="code" optionValue="code" placeholder="Все" filter/>
            <Button label="Добавить" @click='addCurrency()' :loading="loading" severity="secondary"/>
        </div>
                
        <template #footer>
            <div class="pt-3">
                <Button label="Сохранить" @click='save()' :loading="loading" :disabled="loading"/>
            </div>  
        </template>
    </Dialog>
</template>
    
<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'

export default {
    props: ['merchant_id', 'reserves', 'close', 'loading'],
    data() {
        return {
            displayPopup: false,
            currencies: [],
            currency: null,
            newReserves: []
        }
    },
    watch: {
        close(val){
            if(val) this.displayPopup = false
        },
    },
    methods: {
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency)
        },
        async loadCurrencies(){
            const storeCurrencies = this.$store.getters.GetCurrencies
            if(storeCurrencies && Object.keys(storeCurrencies).length) this.currencies = Object.values(storeCurrencies)
            else {
                const resCurrencies = await this.$store.dispatch('GetCurrencies').then(res => res)
                if(resCurrencies && resCurrencies.data) this.currencies = resCurrencies.data
            }
        },
        removeCurrency(currency){
            if(currency){
                const reserves = this.newReserves.filter(r => r.currency_code !== currency)
                this.newReserves = reserves
            }
        },
        async addCurrency(){
            if(this.currency){
                const currency = this.currency
                const exists = this.newReserves.find(r => r.currency_code === currency)
                if(!exists){
                    this.newReserves.push({currency_code: currency, amount: '0'})
                }
            }
        },
        async save(){
            this.$emit('update', this.newReserves)
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    created() {
        this.loadCurrencies()
        this.newReserves = this.reserves
    }
}
</script>